import { AccountCircleRounded } from "@mui/icons-material";
import FolderOpenRoundedIcon from "@mui/icons-material/FolderOpenRounded";
import { Box, Grid, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { icons } from "../../../icons/iconExport";
import { DataStoreResourceTypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AzureSQLDatabaseDetailsView = ({ entityData }) => {
  const [database_logo, database_label] = Object.keys(
    DataStoreResourceTypeIconsAndLabels
  ).includes(entityData.azure_sql_database_data.resource_type)
    ? DataStoreResourceTypeIconsAndLabels[
        entityData.azure_sql_database_data.resource_type
      ]
    : null;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {entityData?.azure_sql_database_data?.status && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.statusIcon} width="16px" />
            <Typography variant="subtitle2">Last Status</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_sql_database_data.status}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.encryption_status && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.encryptionIcon} width="16px" />
            <Typography variant="subtitle2">Encryption Status</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_sql_database_data.encryption_status}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Type</Typography>
          </Box>
          <Box ml={2} display="flex">
            <SvgToIcon IconLogo={database_logo} width="16px" />
            <TextIntegrationStyle
              title=""
              value={database_label}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.resource_id && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serialNumberIcon} width="16px" />
            <Typography variant="subtitle2">Resource ID</Typography>
          </Box>
          <Box ml={2} display="flex">
            <Grid container gap={2} direction="row">
              <Grid item xs={8}>
                <TextIntegrationStyle
                  title=""
                  value={entityData.azure_sql_database_data.resource_id}
                ></TextIntegrationStyle>
              </Grid>
              <Grid item xs={3}>
                <CustomCopyButton
                  copyTitle="Resource ID"
                  copyText={entityData.azure_sql_database_data.resource_id}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.subscription_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <AccountCircleRounded sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Subscription Name</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_sql_database_data.subscription_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.resource_group_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <FolderOpenRoundedIcon sx={{ width: "16px" }} />
            <Typography variant="subtitle2">Resource Group</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_sql_database_data.resource_group_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.sql_server_name && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serversIcon} width="16px" />
            <Typography variant="subtitle2">SQL Server</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_sql_database_data.sql_server_name}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
      {entityData?.azure_sql_database_data?.location && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.regionServerIcon} width="16px" />
            <Typography variant="subtitle2">Location</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={entityData.azure_sql_database_data.location}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AzureSQLDatabaseDetailsView;
